import React, { FC } from 'react';
import './styles.scss';
type Props = {
  data: { brandImage: string | undefined; brandLogo?: string };
};
const BrandImageDetailCard: FC<Props> = ({ data }) => {
  const { brandImage, brandLogo } = data;
  return (
    <div className='py-1 border border-1 rounded-[10px] border-[#EDEDEE]'>
      <p className='px-[24px] py-[18px] font-medium text-[#858585] text-sm'>Brand Images & Logo</p>
      <hr className='text-[#EDEDEE]' />
      <div className='p-6 flex gap-[20px]'>
        <div className='w-[260px] h-[160px] bg-[#F4F5F5] rounded-[10px] flex justify-center items-center'>
          <img className='w-[80px] h-[80px] rounded-full object-cover' src={brandLogo} />
        </div>
        <div className='w-[418px] h-[160px]'>
          <img className='w-full h-full rounded-[10px] object-cover' src={brandImage} />
        </div>
      </div>
    </div>
  );
};

export default BrandImageDetailCard;
